export default "__VITE_ASSET__UFyo0FKe__"